import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IAimsCredentials {
    client_id: string,
    client_secret: string,
    username: string,
    password: string,
}

class AimsCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IAimsCredentials = {} as IAimsCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get client_id() { return this._changes.client_id; }
    public get client_secret() { return this._changes.client_secret; }
    public get username() { return this._changes.username; }
    public get password() { return this._changes.password; }

    public set client_id(v: string) { this._changes.client_id = v; }
    public set client_secret(v: string) { this._changes.client_secret = v; }
    public set username(v: string) { this._changes.username = v; }
    public set password(v: string) { this._changes.password = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }

    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IAimsCredentials;
    }

    public getUpdatedModel(): IAimsCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default AimsCredentialsStore;
